import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "zxForumComment/";

// 论坛评论 - 列表
export const forumCommentPage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "forumList", {
    data: _params,
    method: "GET",
  });
};

// 论坛评论 - 添加
export const forumCommentAdd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "add", {
    data: _params,
    method: "POST",
  });
};

// 论坛评论 - 删除
export const forumCommentRemove = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + `remove/${params.id}`, {
    method: "DELETE",
  });
}; 

// 论坛评论 - 论坛评论点赞
export const forumCommentGiveLike = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "giveLike", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };
       
// 论坛评论 - 论坛评论取消点赞
export const forumCommentCancelLike = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "cancelLike", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };


// WEBPACK FOOTER //
// ./src/fetch/api/forumComment.js